export default {
    RECAPTCHAV2: 1,
    RECAPTCHAV2HIDDEN: 2,
    RECAPTCHAV3: 3,
    1: 'ReCaptchaV2',
    2: 'ReCaptchaV2Hidden',
    3: 'ReCaptchaV3'
};